// src/components/common/Input.jsx
// Reusable input component with validation support

import React from 'react';

const Input = ({
  label,
  icon,
  type = 'text',
  name,
  value,
  onChange,
  placeholder,
  error,
  required,
  disabled,
  maxLength,
}) => {
  return (
    <div className="mb-4">
      {label && (
        <label htmlFor={name} className="block text-gray-700 font-semibold mb-1 dark:text-gray-200">
          {icon && <span className="mr-2">{icon}</span>}
          {label}
        </label>
      )}
      <input
        id={name}
        name={name}
        type={type}
        className={`neumorphic-input w-full ${error ? 'border-red-400' : ''} ${disabled ? 'bg-gray-100 cursor-not-allowed' : ''}`}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        required={required}
        disabled={disabled}
        maxLength={maxLength}
        autoComplete="off"
      />
      {error && <div className="text-red-500 text-xs mt-1">{error}</div>}
    </div>
  );
};

export default Input;
